import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

export function usePrompt(message, when = true) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!when) return;
    
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Trap back button using popstate
    let dummyStatePushed = false;
    if (window.history.state?.idx !== undefined || window.history.state === null) {
      window.history.pushState(null, "", window.location.href);
      dummyStatePushed = true;
    }

    const handlePopState = () => {
      if (window.confirm(message)) {
        window.removeEventListener('popstate', handlePopState);
        window.history.back();
      } else {
        window.history.pushState(null, "", window.location.href);
      }
    };
    
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [message, when]);

  useEffect(() => {
    if (!when || !navigator) return;

    const originalPush = navigator.push;
    const originalReplace = navigator.replace;
    const originalGo = navigator.go;

    navigator.push = (...args) => {
      if (window.confirm(message)) originalPush(...args);
    };

    navigator.replace = (...args) => {
      if (window.confirm(message)) originalReplace(...args);
    };

    navigator.go = (...args) => {
      if (window.confirm(message)) originalGo(...args);
    };

    return () => {
      navigator.push = originalPush;
      navigator.replace = originalReplace;
      navigator.go = originalGo;
    };
  }, [navigator, message, when]);
}
